import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react"
import ReactSelect from "react-select"
import AsyncSelect from "react-select/async"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import { farsiToEnglishDigitConverter } from "utils"
import classes from "./Select.module.scss"

const Select = (props, outerRef) => {
  const {
    error,
    label,
    className,
    async = false,
    value,
    inputValue,
    onFocus = () => { },
    onBlur = () => { },
    selectStyles = {},
    noOptionsMessage,
    loadOptions = () => { },
    ...otherProps
  } = props

  const [t, i18n] = useTranslation()

  const [movePlaceholder, setMovePlaceholder] = useState(false)

  const innerRef = useRef(null)

  useImperativeHandle(outerRef, () => innerRef.current, [])

  const handleFocus = (e) => {
    onFocus(e)

    setMovePlaceholder(true)
  }

  const handleBlur = (e) => {
    onBlur(e)

    !!value || !!inputValue
      ? setMovePlaceholder(true)
      : setMovePlaceholder(false)
  }

  const handleLoadOptions = (inputValue, callback) => {
    const inputRef =
      innerRef.current.select.select.inputRef

    const start =
      inputRef.selectionStart

    const end =
      inputRef.selectionEnd

    const value =
      farsiToEnglishDigitConverter(inputValue)

    // preserve cursor position
    inputRef.setSelectionRange(start, end)

    loadOptions(value, callback)
  }

  useEffect(() => {
    if (!!value) setMovePlaceholder(true)
  }, [value])

  const Component = async ? AsyncSelect : ReactSelect

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <div className={className}>
      <div className={classes["contaienr"]}>
        {
          !!label &&
          <label
            className={clsx(
              classes["placeholder"],
              isLtr && classes["placeholder-ltr"],
              movePlaceholder && classes["move"]
            )}
          >
            {label}
          </label>
        }
        <Component
          placeholder=""
          ref={innerRef}
          loadOptions={handleLoadOptions}
          inputValue={inputValue}
          loadingMessage={() => t("در_حال_بارگذاری")}
          value={value}
          onFocus={handleFocus}
          onBlur={handleBlur}
          noOptionsMessage={
            !!noOptionsMessage
              ? noOptionsMessage
              : () => t("هیچ_آپشنی_یافت_نشد")
          }
          styles={{
            option: (provided, state) => ({
              ...provided,
              fontSize: "14px",
              cursor: "pointer",
              backgroundColor:
                state.isSelected
                  ? "var(--color-primary)"
                  : "inherit"
              ,
              "&:hover": {
                backgroundColor: state.isSelected
                  ? "var(--color-primary)"
                  : "var(--color-primary-alpha-25)"
              }
            }),
            loadingIndicator: (props) => ({
              ...props,
              transform: "scale(0.5)"
            }),
            dropdownIndicator: (props) => ({
              ...props,
              padding: "0px 8px"
            }),
            placeholder: (props) => ({
              ...props,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap"
            }),
            control: (props, state) => ({
              ...props,
              fontSize: "14px",
              minHeight: "33px",
              boxShadow:
                state.isFocused
                  ?
                  !!error
                    ? "0 0 0 0.2rem var(--color-danger-alpha-25)"
                    : "0 0 0 0.2rem var(--color-primary-alpha-25)"
                  : ""
              ,
              borderColor: !!error
                ? "#db3c36"
                :
                state.isFocused
                  ? "var(--color-primary)"
                  : "rgba(0,0,0,0.1)",
              borderWidth: "1px",
              "&:hover": {
                border: !!error
                  ? "1px solid var(--color-danger)"
                  : "1px solid rgba(0,0,0,0.1)"
              }
            }),
            menu: (provided) => ({
              ...provided,
              fontSize: "13px",
              zIndex: 1000
            }),
            ...selectStyles
          }}
          {...otherProps}
        />
      </div>
      {
        !!error &&
        <div className={classes["error"]}>
          {error}
        </div>
      }
    </div>
  )
}

export default forwardRef(Select)